import { useEffect, useRef } from 'react';
import type { Business } from '@/modules/dashboard/dashboardTypes';
import { useSequencesContext } from '../SequencesContext';
import { useBusinessList } from './useBusinessLists';

export function useBusinessInfiniteScroll() {
	const {
		businessesInLists,
		businessesScrollPage,
		hasMoreBusinessesToFetch,
		setBusinessesScrollPage,
		showSendAll,
		allBusinessesSelect
	} = useSequencesContext();

	const { fetchBusinessesInLists, loadingBusiness } = useBusinessList();

	const insideObserverRef = useRef({
		businessesInLists: [] as Business[],
		businessesScrollPage: 1,
		hasMoreBusinessesToFetch: true
	});

	const firstRender = useRef(true);
	const delayForIntersect = useRef(false);

	useEffect(() => {
		insideObserverRef.current = {
			businessesInLists,
			businessesScrollPage,
			hasMoreBusinessesToFetch
		};
	}, [businessesInLists, businessesScrollPage, hasMoreBusinessesToFetch]);

	useEffect(() => {
		if (businessesScrollPage > 1 && !firstRender.current) {
			fetchBusinessesInLists({
				page: businessesScrollPage
			});
		}
		firstRender.current = false;
	}, [businessesScrollPage]);

	function onIntersect() {
		if (showSendAll && allBusinessesSelect === 'UNSELECTED_ALL') return;
		if (
			!delayForIntersect.current &&
			insideObserverRef.current.hasMoreBusinessesToFetch &&
			(insideObserverRef.current.businessesInLists.length || 0) > 0 &&
			!loadingBusiness
		) {
			const newPage = insideObserverRef.current.businessesScrollPage + 1;
			setBusinessesScrollPage(newPage);

			delayForIntersect.current = true;
			setTimeout(() => {
				delayForIntersect.current = false;
			}, 200);
		}
	}

	return {
		onIntersect
	};
}
